export function ScrollAnimationTrigger() {
	const targets = document.querySelectorAll(".js-sa"),
				options = {
				  root: null,
				  rootMargin: "200px 0px -100px",
				  threshold: 0
				};

	if (!targets.length) return;

	const observer = new IntersectionObserver(callback, options);

	targets.forEach((target: Element) => {
    observer.observe(target);
  });

	function callback(entries: IntersectionObserverEntry[]) {
		entries.forEach((entry: IntersectionObserverEntry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-show');
        observer.unobserve(entry.target);
      }
    });
	}
}
